import React, { useEffect, useState } from "react";

const navItems = [
  { id: "home", label: "Home", idx: "01" },
  { id: "experience", label: "Experience", idx: "02" },
  { id: "projects", label: "Work", idx: "03" },
  { id: "contact", label: "Contact", idx: "04" },
];

const SunIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M6.34 17.66l-1.41 1.41M19.07 4.93l-1.41 1.41" />
  </svg>
);

const MoonIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
);

const MenuIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M4 7h16M4 12h16M4 17h16" />
  </svg>
);

const CloseIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
    <path d="M6 6l12 12M18 6L6 18" />
  </svg>
);

const Header = ({ activeSection, scrollProgress, theme, onToggleTheme }) => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = menuOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [menuOpen]);

  return (
    <>
      <header id="portfolio-header" className={scrolled ? "is-scrolled" : ""}>
        <div className="header-inner">
          <a href="#home" className="brand" aria-label="Back to top">
            <span className="brand-dot" aria-hidden="true"></span>
            Alexandru<span style={{ color: "var(--accent)" }}>.</span>
          </a>

          <nav className="header-nav" aria-label="Primary">
            <ul>
              {navItems.map((item) => (
                <li key={item.id}>
                  <a href={`#${item.id}`} className={activeSection === item.id ? "active" : ""}>
                    <span className="idx" aria-hidden="true">{item.idx}</span>
                    {item.label}
                  </a>
                </li>
              ))}
            </ul>
          </nav>

          <div className="header-actions">
            <button
              type="button"
              className="theme-toggle"
              onClick={onToggleTheme}
              aria-label={`Switch to ${theme === "dark" ? "light" : "dark"} mode`}
            >
              {theme === "dark" ? <SunIcon /> : <MoonIcon />}
            </button>
            <button
              type="button"
              className="menu-btn"
              onClick={() => setMenuOpen((o) => !o)}
              aria-label={menuOpen ? "Close menu" : "Open menu"}
              aria-expanded={menuOpen}
            >
              {menuOpen ? <CloseIcon /> : <MenuIcon />}
            </button>
          </div>
        </div>

        <div className="scroll-progress" aria-hidden="true">
          <span style={{ width: `${scrollProgress}%` }}></span>
        </div>
      </header>

      <nav className={`mobile-nav ${menuOpen ? "open" : ""}`} aria-label="Mobile" aria-hidden={!menuOpen}>
        <button
          type="button"
          className="theme-toggle"
          onClick={() => setMenuOpen(false)}
          aria-label="Close menu"
          style={{ position: "absolute", top: "1.15rem", right: "var(--gutter)" }}
        >
          <CloseIcon />
        </button>
        {navItems.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className={activeSection === item.id ? "active" : ""}
            onClick={() => setMenuOpen(false)}
          >
            <span className="idx" aria-hidden="true">{item.idx}</span>
            {item.label}
          </a>
        ))}
      </nav>
    </>
  );
};

export default Header;
